// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"style_sidebar__1_XDx","menuContainer":"style_menuContainer__1vfr2","menuSubMenu":"style_menuSubMenu__1hIK9","menuItem":"style_menuItem__1Tkgm"};